import React from "react";
import { Box, TableCell, TableRow } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DotLegalMultiSelect, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import QuestionnaireStatus from "@common/components/questionnaireComponents/questionnaireStatus/QuestionnaireStatus";
import QuestionnaireEvaluation from "@common/components/questionnaireComponents/questionnaireEvaluation/QuestionnaireEvaluation";
import { useTranslation } from "@localization/useTranslation";
import { InternalAssessmentReportRow, InternalAssessmentReportTableProps } from "../InternalAssessmentReportTable.types";
import useInternalAssessmentReportExcludedAssessments from "./InternalAssessmentReportExcludedAssessments.hooks";
import ManagementReportTableSection, {
    managementReportFilterGridSizes,
} from "@common/components/managementReport/managementReportTableSection/ManagementReportTableSection";

function InternalAssessmentReportExcludedAssessments(props: InternalAssessmentReportTableProps) {
    const { translateString } = useTranslation();
    const { rows, searchedExclusionReason, setSearchedExclusionReason, exclusionReasonFilterOptions } = useInternalAssessmentReportExcludedAssessments(props);

    function getHeaders() {
        const headers = Array<ITableHeader<InternalAssessmentReportRow>>();
        headers.push({ property: "assigneeName", text: translateString("assigned"), align: "left", showOnMobile: true });
        headers.push({ property: "statusString", text: translateString("exclusionReason"), align: "left", showOnMobile: true });
        headers.push({ property: "evaluationStatus", text: translateString("evaluation"), align: "left", showOnMobile: true });

        if (props.isPdf) {
            headers.push({ property: "evaluation", text: translateString("evaluationText"), align: "left", showOnMobile: true });
        }

        return headers;
    }

    function getSearchFields() {
        return (
            <Grid size={managementReportFilterGridSizes}>
                <DotLegalMultiSelect
                    onChange={setSearchedExclusionReason}
                    chosenOptions={searchedExclusionReason}
                    label={translateString("exclusionReason")}
                    placeholder={translateString("exclusionReason")}
                    isLoading={props.isLoading}
                    options={exclusionReasonFilterOptions}
                    noMargin
                    limit={1}
                    noOptionsLabel={translateString("noOptions")}
                />
            </Grid>
        );
    }

    return (
        <ManagementReportTableSection
            title={translateString("excluded")}
            count={props.assessments.length}
            isPdf={props.isPdf}
            headers={getHeaders()}
            defaultOrderBy={"assigneeName"}
            data={rows}
            searchFields={getSearchFields()}
            renderRow={(row) => (
                <TableRow key={row.id}>
                    <TableCell>
                        <Box component={"span"} sx={{ fontWeight: "bold" }}>
                            {row.assigneeName}
                        </Box>
                    </TableCell>
                    <TableCell>
                        <QuestionnaireStatus
                            showQuestionsStatistics={row.showQuestionsStatistics}
                            numberOfQuestionsAnswered={row.numberOfQuestionsAnswered}
                            totalNumberOfQuestions={row.totalNumberOfQuestions}
                            status={row.status}
                            lastestRecipientUpdate={row.lastestRecipientUpdate}
                        />
                    </TableCell>
                    <TableCell>
                        <QuestionnaireEvaluation evaluationStatus={row.evaluationStatus} evaluation={row.evaluation} />
                    </TableCell>
                    {props.isPdf && <TableCell>{row.evaluation}</TableCell>}
                </TableRow>
            )}
        />
    );
}

export default InternalAssessmentReportExcludedAssessments;
